import React from "react";
import { Instagram, Facebook, ArrowUpRight } from "lucide-react";
import { STUDIO, NAV_LINKS } from "@/data/site";
import { scrollTo } from "./Navigation";
import WhatsAppIcon from "./icons/WhatsAppIcon";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1A1A] text-[#FDFBF7] py-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-6">
            <h2 className="font-serif-display text-6xl md:text-8xl lg:text-9xl leading-none tracking-tight">
              lsb<span className="text-[#C5A059]">·</span>studio
            </h2>
            <p className="text-white/60 mt-8 max-w-md leading-relaxed">
              A boutique photography practice for life&apos;s most elegant chapters.
              New York / New Jersey — available worldwide.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-[#C5A059] mb-6">Explore</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollTo(l.id)}
                    className="text-white/80 hover:text-[#C5A059] transition-colors text-sm tracking-wide"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-[#C5A059] mb-6">Studio</p>
            <ul className="space-y-3 text-sm text-white/80">
              <li>{STUDIO.address.line1}</li>
              <li>{STUDIO.address.line2}</li>
              <li className="pt-3">
                <a
                  href={`mailto:${STUDIO.email}`}
                  className="link-underline"
                  data-testid="footer-email"
                >
                  {STUDIO.email}
                </a>
              </li>
              <li>
                <a
                  href={STUDIO.social.whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  className="link-underline"
                  data-testid="footer-phone"
                >
                  {STUDIO.phone}
                </a>
              </li>
            </ul>

            <div className="flex items-center gap-5 mt-8">
              <a
                href={STUDIO.social.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="text-white/80 hover:text-[#C5A059] transition-colors"
              >
                <Instagram size={18} />
              </a>
              <a
                href={STUDIO.social.whatsapp}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="text-white/80 hover:text-[#C5A059] transition-colors"
              >
                <WhatsAppIcon size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-10 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50 tracking-wide">
          <p>© {new Date().getFullYear()} {STUDIO.domain}. All rights reserved.</p>
          <button
            data-testid="footer-back-to-top"
            onClick={() => scrollTo("hero")}
            className="group inline-flex items-center gap-2 uppercase tracking-[0.24em] hover:text-[#C5A059] transition-colors"
          >
            Back to top
            <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </button>
        </div>
      </div>
    </footer>
  );
}
